module.exports = __webpack_public_path__ + "static/media/Personalities.8ce88ea6.png";